import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoomDetectionManueel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 23 22",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		transform: "matrix(0.889151,0,0,0.944264,0.991365,-0.222602)",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.807596,0,0,0.717499,9.845284,21.382889)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0,-21.867L7.441,-21.867C9.002,-21.867 10.269,-20.518 10.269,-18.855L10.269,-13.895",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		}), /* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.807596,0,0,0.717499,9.845284,21.382889)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3.263,0L-8.754,0C-10.316,0 -11.582,-1.348 -11.582,-3.012L-11.582,-18.855C-11.582,-20.518 -10.316,-21.867 -8.754,-21.867L-6.088,-21.867L-2.654,-18.432",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		})]
	}), /* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.27945,0.96016,0.96016,-0.27945,20.538365,11.165213)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Laag-1",
			"serif:id": "Laag 1",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M-1.246,-7.317L8.104,-7.317L5.519,-4.52L5.201,-0.337L-1.246,-7.317Z",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		})
	})]
});
export default SvgRoomDetectionManueel;
